import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationTokenService {
  private _token: string | undefined;

  set(accessToken: string) {
    this._token = `Bearer ${accessToken}`;
  }

  get(): string {
    return this._token || '';
  }
}
